import axios from 'axios'

let refresherAxiosInstance = axios.create()

export {refresherAxiosInstance}



// WEBPACK FOOTER //
// ./src/services/api/refresh_client.js